import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PackVerification_ds_shippingcontainers_failed_verification_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Notes?: string, ShippingDate?: string, Shipment?: { ActualWarehouseId?: number, ExpectedDate?: string, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string }, OrderLookups?: { CreatedSysDateTime?: string, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, RequestedDeliveryDate?: string, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } } } }[] }, TasksForActualSourceShippingContainer?: { Id?: number, StatusId?: number, ReasonCode?: { Name?: string } }[], LicensePlates?: { Id?: number, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, MaterialId?: number } }[], Location?: { Name?: string } }[], ContainerType?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_shippingcontainers_failed_verification_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Notes?: string, ShippingDate?: string, Shipment?: { ActualWarehouseId?: number, ExpectedDate?: string, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string }, OrderLookups?: { CreatedSysDateTime?: string, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, RequestedDeliveryDate?: string, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } } } }[] }, TasksForActualSourceShippingContainer?: { Id?: number, StatusId?: number, ReasonCode?: { Name?: string } }[], LicensePlates?: { Id?: number, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, MaterialId?: number } }[], Location?: { Name?: string } }[], ContainerType?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_shippingcontainers_failed_verification_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Notes?: string, ShippingDate?: string, Shipment?: { ActualWarehouseId?: number, ExpectedDate?: string, Carrier?: { Name?: string }, CarrierServiceType?: { Name?: string }, OrderLookups?: { CreatedSysDateTime?: string, Order?: { Id?: number, LookupCode?: string, OwnerReference?: string, RequestedDeliveryDate?: string, PreferredCarrier?: { Name?: string }, PreferredCarrierServiceType?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { LookupCode?: string } } } }[] }, TasksForActualSourceShippingContainer?: { Id?: number, StatusId?: number, ReasonCode?: { Name?: string } }[], LicensePlates?: { Id?: number, LicensePlateContents?: { PackagedId?: number, PackagedAmount?: number, Lot?: { Id?: number, MaterialId?: number } }[], Location?: { Name?: string } }[], ContainerType?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/datasources/ds_shippingcontainers_failed_verification_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseId?: number, locationId?: number, ownerId?: number, projectId?: number, shippingDate?: string, shippingContainerCode?: string, fullTextSearch?: string    }) {
      return false;
    }
}
